import {createSlice} from "@reduxjs/toolkit";
import {
  clearToggleDriverActivityDayPagePerson,
  setDriverActivityDayPageFilter,
  setDriverActivityDayPageState,
  toggleDriverActivityDayPagePerson
} from "./actions";
import {GridState} from "@ag-grid-community/core";
import {DEFAULT_DRIVER_ACTIVITY_FILTER, DriverActivityFilterFormValues} from "@ots-frontend/ots-ui";

type State = {
  filter: DriverActivityFilterFormValues
  hiddenPersonIds: string[]
  state?: GridState
}

const INITIAL_STATE: Readonly<State> = {
  filter: DEFAULT_DRIVER_ACTIVITY_FILTER,
  hiddenPersonIds: [],
  state: undefined
};

const driverActivityDayPageSlice = createSlice({
  name: "ui/driver-activity-day-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setDriverActivityDayPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
    builder.addCase(
      setDriverActivityDayPageState,
      (state, {payload}) => {
        state.state = payload
      }
    );
    builder.addCase(
      toggleDriverActivityDayPagePerson,
      (state, {payload},) => {
        const index = state.hiddenPersonIds.findIndex(id => id === payload)
        if (index === -1) {
          state.hiddenPersonIds.push(payload)
        } else {
          state.hiddenPersonIds.splice(index, 1)
        }
      }
    );
    builder.addCase(
      clearToggleDriverActivityDayPagePerson,
      (state, {payload},) => {
        state.hiddenPersonIds = []
      }
    );
  }
});

export const driverActivityDayPageReducer = driverActivityDayPageSlice.reducer;
